module.exports = __webpack_public_path__ + "img/section3-1-desktop.40be3ef4.png";